import type { UseFormReturn } from 'react-hook-form';

import { FormField, FormInput } from '@/_components';

import type { CompanyFormSchema } from './schemas';

export function FormFields({
  form,
  isEditable = true,
}: {
  form: UseFormReturn<CompanyFormSchema>;
  isEditable?: boolean;
}) {
  return (
    <>
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6"
            label="Company (required)"
            {...field}
            disabled={!isEditable}
          />
        )}
      />

      <FormField
        control={form.control}
        name="short_name"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6"
            label="Short Name"
            {...field}
            disabled={!isEditable}
          />
        )}
      />
    </>
  );
}
